export default __webpack_public_path__ + "media/doctor.447ec342.png";